import {VatRateType, Price} from '@dms/api/shared';

export type CreateProductApiResponse = /** status 201  */ ProductResponseBody;
export type CreateProductApiArg = {
  body: ProductRequestBody;
};
export type DeleteProductApiResponse = unknown;
export type DeleteProductApiArg = {
  id: string;
};
export type EditProductApiResponse = /** status 200  */ ProductResponseBody;
export type EditProductApiArg = {
  id: string;
  body: ProductRequestBody;
};

export type VatPrice = {
  priceWithVat: Price;
  priceWoVat: Price;
  vatRate: string;
  vatType: VatRateType;
};
export type ProductResponseBody = {
  id: string;
  name: string;
  sellingPrice: VatPrice;
  purchasePrice: VatPrice | null;
  createdAt: string;
  accountingContextCustomItemCode: string | null;
};
export type ProductRequestBody = {
  name: string;
  sellingPrice: VatPrice;
  purchasePrice: VatPrice | null;
  accountingContextCustomItemCode: string | null;
};
export type GetProductApiArg = {
  productId: string;
};
export type GetProductApiResponse = /** status 200  */ ProductResponseBody;
